<template>
<div class="selectradio" ref="selectradio">
  <RadioGroup class="reason-radiolist" v-model="evidence">
    <div class="reason-title">
      {{ radioData.question }}
    </div>
    <div class="reason-radioitem" v-for="(item, index) in radioData.answer" :key="index">
      <Radio
        :name="item.id"
        >{{item.desc}}
      </Radio>
      <div v-if="item.order">
        <div v-show="item.id === evidence && selectOrder.length>0" class="showorder">
          <OrderItem
            v-for="(item,index) in selectOrder"
            :key="index"
            :item="item">
          </OrderItem>
          <z-button @click="changeOrder" type="link">修改订单</z-button>
          <z-divider></z-divider>
        </div>
      </div>
      <div v-if="item.letter">
        <div v-show="item.id === evidence && selectLetter.length > 0" class="showletterwrap">
          <div class="showletter">
            <LetterItem
              v-for="(item,index) in selectLetter"
              :key="index"
              :item="item">
            </LetterItem>
          </div>
          <z-button @click="changeLetter" type="link">修改私信</z-button>
          <z-divider></z-divider>
        </div>
      </div>
      <div v-if="item.product">
        <div v-show="item.id === evidence && selectProduct.length > 0" class="showproduct">
          <ProductItem
            v-for="(item,index) in selectProduct"
            :key="index"
            :item="item">
          </ProductItem>
          <z-button @click="changeProduct" type="link">修改商品</z-button>
          <z-divider></z-divider>
        </div>
      </div>
      <div v-if="item.outer">
        <div v-show="item.id === evidence" class="showouter">
          <div class="tip">请上传您与对方站外聊天截图、转账记录等：</div>
          <div class="upload">
            <z-upload
              ref="upload"
              v-model="outerUpload"
              accept="image/*"
              :max="9"
              @file-success="fileSuccess"
              @file-click="fileClick"
              @file-removed="fileRemove"
              @files-added="filesAdded"
              btnUploadInfo="上传凭证"
              dropOriginFile
              :draggable="false"
            >
            </z-upload>
          </div>
        </div>
      </div>
    </div>
  </RadioGroup>
  <OrderList @select="OrderSelect" :show="showOrder" @close="closeOrder"></OrderList>
  <LetterList @select="LetterSelect" :show="showLetter" @close="closeLetter"></LetterList>
  <ProductList @select="ProductSelect" :show="showProduct" @close="closeProduct"></ProductList>
</div>
</template>

<script>
import OrderList from '../OrderList'
import LetterList from '../LetterList'
import ProductList from '../ProductList'
import OrderItem from '../OrderList/OrderItem'
import LetterItem from '../LetterList/LetterItem'
import ProductItem from '../ProductList/ProductItem'
import { Radio, RadioGroup, Button, Upload, Divider, ImagePreview } from '@zz-common/zz-ui'
export default {
  name: 'ChooseRadio',
  props: {
    radioData: {
      type: Object,
      default: () => {
        return {
          question: '',
          answer: []
        }
      }
    },
    Finished: {
      type: Function,
      default: () => {}
    }, //向外传递数据
    cache: {
      type: Object,
      default: () => {
        return {
          evidence: '',
          files: []
        }
      }
    }
  },
  inject: ['toggleEvidenceLoading'],
  components: {
    Radio,
    RadioGroup,
    zButton: Button,
    'z-upload': Upload,
    'z-divider': Divider,
    OrderList,
    LetterList,
    ProductList,
    OrderItem,
    LetterItem,
    ProductItem
  },
  data() {
    return {
      evidence: '',
      desc: '',
      showOrder: false,
      showProduct: false,
      showLetter: false,
      showOuter: false,

      selectOrder: [],
      selectProduct: [],
      selectLetter: [],
      outerUpload: []
    }
  },
  created() {
    this.evidence = this.cache.evidence || ''
    this.outerUpload = this.cache.files || []
  },
  watch: {
    evidence(val) {
      const item = this.radioData.answer.find((item, _index) => item.id == val)
      //console.log('kankan', val, item)
      if (!item) {
        this.onFinished()
        return
      }
      this.desc = item.desc
      if (item.order) {
        this.showOrder = true
      }
      if (item.product) {
        this.showProduct = true
      }
      if (item.letter) {
        this.showLetter = true
      }
      if (item.outer) {
        this.showOuter = true
        this.$nextTick(() => {
          this.$refs.selectradio.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
        })
      }
      this.onFinished()
    }
  },
  computed: {
  },
  methods: {
    onFinished() {
      console.log('看看selectradio数据', {
        evidence: this.evidence,
        desc: this.desc,
        selectOrder: this.selectOrder,
        selectProduct: this.selectProduct,
        selectLetter: this.selectLetter,
        outerUpload: this.outerUpload
      })
      this.Finished({
        evidence: this.evidence,
        desc: this.desc,
        selectOrder: this.selectOrder,
        selectProduct: this.selectProduct,
        selectLetter: this.selectLetter,
        outerUpload: this.outerUpload
      })
    },
    //关闭操作
    closeOrder() {
      this.showOrder = false
      if (this.selectOrder.length == 0) {
        this.evidence = ''
      }
    },
    closeProduct() {
      this.showProduct = false
      if (this.selectProduct.length == 0) {
        this.evidence = ''
      }
    },
    closeLetter() {
      this.showLetter = false
      if (this.selectLetter.length == 0) {
        this.evidence = ''
      }
    },
    //选择操作
    OrderSelect(data) {
      this.selectOrder = data
      if (data.length == 0) {
        this.evidence = ''
      } else {
        this.onFinished()
      }
    },
    ProductSelect(data) {
      this.selectProduct = data
      if (data.length == 0) {
        this.evidence = ''
      } else {
        this.onFinished()
      }
    },
    LetterSelect(data) {
      this.selectLetter = data
      if (data.length == 0) {
        this.evidence = ''
      } else {
        this.onFinished()
      }
    },
    //修改操作
    changeOrder() {
      this.showOrder = true
    },
    changeProduct() {
      this.showProduct = true
    },
    changeLetter() {
      this.showLetter = true
    },
    filesAdded() {
      this.toggleEvidenceLoading(true)
    },
    fileSuccess() {
      if (this.$refs.upload[0].isComplete()) {
        this.toggleEvidenceLoading(false)
      }
      this.onFinished()
    },
    fileRemove() {
      if (this.$refs.upload[0].isComplete()) {
        this.toggleEvidenceLoading(false)
      }
      this.onFinished()
    },
    fileClick(data) {
      console.log('看看对象', data)
      if (/image/g.test(data.type)) {
        ImagePreview({
          images: [data.url],
          showClose: true,
          showLoading: true
        });
      }
      if (/video/g.test(data.type)) {
        ImagePreview({
          videoVos: [{
            auto: false,
            muteBtn: false,
            controls: true,
            videoUrl: data.url
          }],
          startPosition: 0,
          withVideo: true,
          showClose: true,
          adaptHeight: true,
          adaptApp: true,
          showLoading: true
        });
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import "index.less";
</style>